import { render, staticRenderFns } from "./HFVideo.vue?vue&type=template&id=5b8c945f&scoped=true"
import script from "./HFVideo.vue?vue&type=script&lang=js"
export * from "./HFVideo.vue?vue&type=script&lang=js"
import style0 from "./HFVideo.vue?vue&type=style&index=0&id=5b8c945f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8c945f",
  null
  
)

export default component.exports